import { useState } from 'react';

const useToggle = (initialValue: boolean = false) => {
  const [value, setValue] = useState<boolean>(initialValue);

  const toggle = () => setValue(!value);
  const setTrue = () => setValue(true);
  const setFalse = () => setValue(false);

  return {
    value,
    setTrue,
    setFalse,
    toggle,
  };
};

export default useToggle;
